import React from 'react';
import { T } from 'Actions/translate';

class OrderPromotionCode extends React.Component {
    render() {
        let { className, promotionCode } = this.props;

        if(!promotionCode) return null;

        return(
            <div className={ className }>
                <label>{T('promotion_code')} </label>
                <p>{ promotionCode }</p>
            </div>
        );
    }
}

export default OrderPromotionCode;
